import type { FieldDef, SectionDef } from './types.js'
import { evaluateCondition, isFieldVisible, type ConditionContext } from './conditions.js'

/**
 * Fields of a section that are visible in this context, honouring both the block's
 * own `visibleWhen` and each field's. A field inside a hidden block is not visible,
 * so it is neither validated nor counted towards completion — an Investment must not
 * be asked for Exit details.
 */
export function visibleSectionFields(section: SectionDef, ctx: ConditionContext): FieldDef[] {
  const out: FieldDef[] = section.fields.filter((f) => isFieldVisible(f, ctx))
  for (const block of section.blocks ?? []) {
    if (!evaluateCondition(block.visibleWhen, ctx)) continue
    out.push(...block.fields.filter((f) => isFieldVisible(f, ctx)))
  }
  return out
}

/** Every field of a section regardless of visibility, for rendering and export ordering. */
export function allSectionFields(section: SectionDef): FieldDef[] {
  return [...section.fields, ...(section.blocks ?? []).flatMap((b) => b.fields)]
}
